import React from "react";
import Navbar from "../Navbar/Navbar";
import Bredcom from "../Bredcom/Bredcom";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";

function ArbitraznoPravoPM() {
  return (
    <>
      <Navbar />
      <Bredcom title="Početna" subtitle="Arbitražno pravo" />
      <div className="container mt-4 pt-40">
        <div className="row">
          <div className="col-md-8">
            <div className="content-container">
              <h2 className="section-title">Arbitražno pravo</h2>
              <p>
                <strong>Studijski program:</strong> Pravo
              </p>
              <p>
                <strong>Naziv predmeta:</strong> Arbitražno pravo
              </p>
              <p>
                <strong>Nastavnik:</strong>
              </p>
              <p>
                <strong>Status predmeta:</strong> Obavezan
              </p>
              <p>
                <strong>Broj ECTS:</strong> 8
              </p>
              <p>
                <strong>Uslov:</strong> nema
              </p>
              <h3>Cilj predmeta</h3>
              <p>
                Osnovni cilj predmeta Arbitražno pravo je sticanje znanja i
                profesionalne vještine koje se odnose na arbitražno rješavanje
                sporova u građanskoj i trgovačkoj materiji, sticanje jasne
                predstave o prednostima arbitražnog rješavanja sporova,
                formiranje arbitraže i instiucionalna pitanja, problem
                mjerodavnog procesnog i materijalnog prava pred arbitražama,
                arbitražna klauzula i arbitražni sporazum, pravni okvir u kojem
                su takvi sporazumi mogući, režim priznanja i izvršenja stranih
                arbitražnih odluka, upoznavanje sa uporednim rješenjima i
                aktuelnim i budućim tendencijama.
              </p>
              <h3>Ishod predmeta</h3>
              <p>
                Po uspješnom završetku ovog predmeta studenti će biti sposobni
                da svestranije i sa više razumijevanja shvate važnost
                arbitražnog rješavanja sporova, rješenja koja se odnose na
                međunarodnu trgovačku arbitražu i na međunarodno trgovačko
                mirenje te kao pravni savjetnici ili zastupnici ispravno
                savjetuju svoje klijente o povoljnosti i prihvatljivosti
                arbitražnog rješavanja sporova ili uspješnom učestvovanju i
                vođenju istih. Takođe studenti će biti sposobni da: definišu i
                objasne osnovne pojmove međunarodne trgovačke arbitraže,
                primijene odgovarajuće pravno pravilo na određeni slučaj
                međunarodne trgovačke arbitraže, odrede mjerodavno pravo za
                konkretan slučaj.
              </p>
              <h3>Sadržaj predmeta</h3>
              <p>
                Pojam arbitraže i alternativnih načina rješavanja sporova
                (medijacija itd.); Prednosti i mane arbitražnog rješavanja
                sporova; Pravna priroda i pravni okvir arbitraže; Vrste
                arbitraža; Arbitražni sporazum; Mjerodavno procesno i
                materijalno pravo; Vrste arbitražnih sporazuma i njihova
                sadržina; Punovažnost i autonomija arbitražnih sporazuma; Izbor
                i imenovanje arbitara; Nezavisnost i nepristrasnost arbitara;
                Izuzeće i zamjena arbitra; Nadležnost arbitraža; Odvijanje
                postupka pred arbitražom; Uloga sudova; Arbitražna odluka i
                njeni efekti; Poništaj arbitražne odluke; Priznanje i izvršenje
                arbitražnih odluka; Investicione arbitraže; ICSID; Ad hoc
                arbitraža po arbitražnim pravilima UNCITRAL-a i Arbitražni sud
                MTK u Parizu kao forumi za rješavanje investicionih sporova.
              </p>

              <h3>Metode izvođenja nastave</h3>
              <p>
                Predavanja i vježbe, seminarski rad, kolokvijumi, završni ispit.
                Interaktivna nastava koja obuhvata uvodno izlaganje od strane
                predavača i učešće studenata; studenti su obavezni da se
                pripreme za nastavu i da učestvuju u diskusiji; Predavanja i
                vježbe praćena su odgovarajućim posebno izrađenim
                prezentacijama. Analiza sudske i arbitražne prakse; rješavanje
                hipotetičkih slučajeva.
              </p>

              <h3 className="pt-20 pb-10">Plan rada</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Nedjelja</th>
                    <th>Fond časova</th>
                    <th>Sadržaj</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Pripremna</td>
                    <td>Upoznavanje, dogovor o radu i slično</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>I</td>
                    <td>4P + 1V</td>
                    <td>
                      Pojam arbitraže i alternativnih načina rješavanja sporova
                      (medijacija itd.)
                    </td>
                  </tr>
                  <tr>
                    <td>II</td>
                    <td>4P + 1V</td>
                    <td>Prednosti i mane arbitražnog rješavanja sporova</td>
                  </tr>
                  <tr>
                    <td>III</td>
                    <td>4P + 1V</td>
                    <td>Pravna priroda i pravni okvir arbitraže</td>
                  </tr>
                  <tr>
                    <td>IV</td>
                    <td>4P + 1V</td>
                    <td>Vrste arbitraža; Arbitražni sporazum</td>
                  </tr>
                  <tr>
                    <td>V</td>
                    <td>4P + 1V</td>
                    <td>Mjerodavno procesno i materijalno pravo</td>
                  </tr>
                  <tr>
                    <td>VI</td>
                    <td>4P + 1V</td>
                    <td>Kolokvijum I</td>
                  </tr>
                  <tr>
                    <td>VII</td>
                    <td>4P + 1V</td>
                    <td>
                      Vrste arbitražnih sporazuma i njihova sadržina;
                      Punovažnost i autonomija arbitražnih sporazuma
                    </td>
                  </tr>
                  <tr>
                    <td>VIII</td>
                    <td>4P + 1V</td>
                    <td>
                      Izbor i imenovanje arbitara; Nezavisnost i nepristrasnost
                      arbitara; Izuzeće i zamjena arbitra
                    </td>
                  </tr>
                  <tr>
                    <td>IX</td>
                    <td>4P + 1V</td>
                    <td>
                      Nadležnost arbitraža; Odvijanje postupka pred arbitražom;
                      Uloga sudova
                    </td>
                  </tr>
                  <tr>
                    <td>X</td>
                    <td>4P + 1V</td>
                    <td>Arbitražna odluka i njeni efekti</td>
                  </tr>
                  <tr>
                    <td>XI</td>
                    <td>4P + 1V</td>
                    <td>Poništaj arbitražne odluke</td>
                  </tr>
                  <tr>
                    <td>XII</td>
                    <td>4P + 1V</td>
                    <td>Kolokvijum II</td>
                  </tr>
                  <tr>
                    <td>XIII</td>
                    <td>4P + 1V</td>
                    <td>Priznanje i izvršenje arbitražnih odluka</td>
                  </tr>
                  <tr>
                    <td>XIV</td>
                    <td>4P + 1V</td>
                    <td>Investicione arbitraže</td>
                  </tr>
                  <tr>
                    <td>XV</td>
                    <td>4P + 1V</td>
                    <td>
                      ICSID; Ad hoc arbitraža po arbitražnim pravilima
                      UNCITRAL-a i Arbitražni sud MTK u Parizu kao forumi za
                      rješavanje investicionih sporova
                    </td>
                  </tr>
                  <tr>
                    <td>XVI</td>
                    <td>Sveobuhvatni ispit</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>XVII</td>
                    <td>Ovjera semestra i upis ocjena</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>XVIII</td>
                    <td>Popravni ispitni rok</td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
              <h3 className="pt-20 pb-10">Obaveze studenata</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Obaveze studenata</th>
                    <th>U toku nastave</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Obaveze studenata u toku nastave</td>
                    <td>
                      Studenti su obavezni da pohađaju nastavu, vježbe i ispite
                    </td>
                  </tr>
                  <tr>
                    <td>Konsultacije</td>
                    <td>
                      Konsultacije se održavaju sa nastavnikom i saradnikom
                      poslije časova
                    </td>
                  </tr>
                  <tr>
                    <td>Opterećenje studenata u časovima</td>
                    <td>
                      <table className="table table-bordered ofpep-section">
                        <thead>
                          <tr>
                            <th>Nedjeljno</th>
                            <th>U semestru</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Ukupno: 5 č / 3.45h</td>
                            <td>Ukupno: 90 č</td>
                          </tr>
                          <tr>
                            <td>Predavanja: 4 č / 3h</td>
                            <td>Nastava + završni ispit: 65 č</td>
                          </tr>
                          <tr>
                            <td>Vježbe: 1 č / 0.45h</td>
                            <td>Priprema i ovjera semestra: 10 č</td>
                          </tr>
                          <tr>
                            <td>Individualni rad:</td>
                            <td>Priprema i polaganje popravnog ispita: 15 č</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
              <h3 className="pt-20 pb-10">Ocjenjivanje</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Ocjena</th>
                    <th>Broj poena</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>A(odličan)</td>
                    <td>91-100</td>
                  </tr>
                  <tr>
                    <td>B(vrlo dobar)</td>
                    <td>81-90</td>
                  </tr>
                  <tr>
                    <td>C(dobar)</td>
                    <td>71-80</td>
                  </tr>
                  <tr>
                    <td>D(zadovoljava)</td>
                    <td>61-70</td>
                  </tr>
                  <tr>
                    <td>E(dovoljan)</td>
                    <td>51-60</td>
                  </tr>
                  <tr>
                    <td>F(nedovoljan)</td>
                    <td>0-50</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="col-md-4 pt-10">
            <aside className="sidebar-widget">
              <section
                id="custom_html-5"
                className="widget_text widget widget_custom_html"
              >
                <h2 className="widget-title">Zapratite nas</h2>
                <div className="textwidget custom-html-widget">
                  <div className="widget-social">
                    <a
                      href="https://www.facebook.com/fpebar.me"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a
                      href="https://www.instagram.com/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-instagram" />
                    </a>
                    <a
                      href="https://www.youtube.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-youtube" />
                    </a>
                    <a
                      href="https://www.tiktok.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on Tiktok"
                      title="Tiktok"
                    >
                      <i className="fab fa-tiktok" />
                    </a>
                    <a
                      href="https://www.linkedin.com/school/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on LinkedIn"
                      title="LinkedIn"
                    >
                      <i className="fab fa-linkedin-in" />
                    </a>
                  </div>
                </div>
              </section>
              <section id="categories-1" className="widget widget_categories">
                <h2 className="widget-title">Korisni linkovi</h2>
                <ul>
                  <li className="cat-item cat-item-16">
                    <Link to="/o-fpep">O Fakultetu</Link>
                  </li>
                  <li className="cat-item cat-item-23">
                    <Link to="/akreditacija-fpep">Akreditacija FPEP-a</Link>
                  </li>
                  <li className="cat-item cat-item-18">
                    <Link to="/upis">Upis</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/cijene-studija">Školarina</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/erasmus">Erasmus+</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/projekti">Projekti</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/dom-studenata">Dom studenata</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/galerija">Galerija</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/novosti">Novosti</Link>
                  </li>
                </ul>
              </section>
              <section
                id="recent-posts-4"
                className="widget widget_recent_entries"
              >
                <h2 className="widget-title">Studijski programi</h2>
                <ul>
                  <li>
                    <span className="post-date">
                      <strong>Osnovne studije</strong> <br />
                    </span>
                    <Link to="/racunovodstvo-finansije-i-bankarstvo">
                      Računovodstvo, bankarstvo i finansije
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/menadzment">
                      Menadžment
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-osnovne">
                      Pravo
                      <br />
                    </Link>
                  </li>
                  <li>
                    <span className="post-date">
                      <strong>Master studije</strong> <br />
                    </span>
                    <Link to="/poslovna-ekonomija">
                      Poslovna ekonomija
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/ekonomija-javnog-sektora">
                      Ekonomija javnog sektora
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-master">
                      Pravo
                      <br />
                    </Link>
                  </li>
                </ul>
              </section>
            </aside>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default ArbitraznoPravoPM;
